import StencilHTMLElement from "./stencil-element";

class ProductUpsell extends StencilHTMLElement {
  name = "ProductUpsell";
  miniCart;
  productUpsellCard;
  parentElement;

  constructor() {
    super();
    this.miniCart = document.querySelector("#cart-offcanvas");
    this.productUpsellCard = document.querySelector("product-upsell");

    if (this.productUpsellCard) {
      this.parentElement = this.productUpsellCard.closest(".cart-upsell");
    }

    document.addEventListener("minicart:rendered", this.showProductUpsellCard.bind(this));
    if (this.miniCart) {
      this.miniCart.addEventListener("hidden.bs.offcanvas", this.miniCartHidden.bind(this));
    }
  }

  showProductUpsellCard() {
    if (this.parentElement) {
      this.parentElement.classList.remove("visually-hidden");
    }
  }

  miniCartHidden() {
    if (this.parentElement) {
      this.parentElement.classList.add("visually-hidden");
    }
  }

  
}

export default ProductUpsell;
